import { formatDate } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute } from '@angular/router';
import { User } from 'src/app/core/interfaces/auth/user';
import { Zone } from 'src/app/core/interfaces/zones/zone';
import { ApiService } from 'src/app/core/services/api/api.service';
import { DataService } from 'src/app/core/services/data/data.service';

@Component({
  selector: 'app-production-calendar-filters',
  templateUrl: './production-calendar-filters.component.html',
  styleUrls: ['./production-calendar-filters.component.scss'],
})
export class ProductionCalendarFiltersComponent implements OnInit {
  zones: Zone[];
  selectedZone: string;

  foremanArray: User[];
  selectedForeman: User;

  currentPath: string;

  @Output() filterAppointments = new EventEmitter<string>();

  constructor(
    private data: DataService,
    private apiService: ApiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.data.currentPath.subscribe((path) => {
      this.currentPath = path;
    });
    // api call to get zones
    this.apiService.getAllZones().subscribe((zones) => {
      this.zones = zones;
    });
  }

  getForemanByZone(zoneId: number) {
    let dateString = formatDate(new Date(), 'MM/dd/yyyy', 'en-US');

    this.apiService
      .getForemanByZone(zoneId, dateString)
      .subscribe((foreman) => {
        this.foremanArray = foreman;
      });
  }

  selectZone(event: MatSelectChange) {
    this.data.changeZone(event.value);
  }

  selectForeman(event: MatSelectChange) {
    this.data.changeForeman(event.value);
  }

  ngOnDestroy(): void {
    this.data.changeZone(null);
  }
}
